<template>
  <kst-page-print-list pageFooter
    v-slot="{ title }"
    :catalog="SearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <List class="mt-4" :items="items"/>
  </kst-page-print-list>
</template>

<script>
import Model from "../DebtModel.js";
import SearchCatalog from "../List/SearchCatalog.js";
import Services from "../../../services/Api/DebtServices.js";

import List from "./DebtPL_List.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    List,
    Company
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    companyData: {},
    items: [],
    searchData: {
      Search: "",
      VendorID: null, 
      VendorName: "",
      Date: null,
      WarehouseID: null
    },
    searchParams: ["Search", "VendorID", "VendorName", "Date", "WarehouseID"]
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadPrint) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getPrintListData(options);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.companyData = data.CompanyDetails;
      this.items = data.List;
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.items = [];
    },
    resetSearch() {
      this.searchData.Search = "";
      this.searchData.VendorID = null;
      this.searchData.VendorName = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },
    getListOptions() {
      const vendorId = this.$kst.Out.getInteger(this.searchData.VendorID);
      const vendorName = vendorId === null
        ? this.$kst.Out.getString(this.searchData.VendorName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        vendor: vendorId,
        vendorname: vendorName,
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.Fields
      };
    }
  }
}
</script>